export default {
  common: {
    confirm: '확인',
    confirmed: '확인 완료',
    cancel: '취소',
    select: '선택하세요',
    search: '조회',
    notice: '알림',
    confirmRole: '역할 정보 확인',
    announce: '공고',
    currency: '₩'
  },
  pay: {
    title: {
      SelectCharacter: '캐릭터 선택',
      SelectBundle: '상품 선택',
      game: '게임',
      gamePlaceholder: '게임 선택',
      server: '구 복',
      serverPlaceHolder: '옷을 고르다',
      role: '역할',
      rolePlaceHolder: '배역을 선택하다'
    },
    instructions: {
      title: '이용 가이드',
      subtext: '서비스 안내',
      paragraph1: '1. 귀하의 권익을 보호하기 위해, 상품 구매 전 반드시 상품 상세 정보를 확인하시기 바랍니다.',
      paragraph2:
        '2. 본 서비스는 게임 내 캐릭터 생성을 완료한 사용자에게만 제공됩니다. 캐릭터를 생성하지 않은 경우 해당 서버/캐릭터 정보를 조회할 수 없으니 반드시 생성 완료 후 이용하시기 바랍니다.',
      paragraph3:
        '3. 주의사항: 서버 및 캐릭터 ID 입력 후 계정 정보를 반드시 재확인하시고, 정확한 경우에만 다음 단계를 진행해 주세요!',
      paragraph4:
        '4. 결제 완료 후, 본 페이지에서 구매한 상품은 게임 내 우편으로 발송됩니다. 결제 완료 30분 후에도 수령하지 못한 경우 게임 내 고객센터를 통해 문의해 주시면 신속히 처리해 드리겠습니다. (고객센터 이용법:  인게임 플로팅 버튼 --> 고객센터)',
      paragraph5:
        '5. 네트워크 지연 등으로 실제 게임 내 반영 시간이 다소 지연될 수 있으며, 최종 반영 여부는 게임 내 실제 상황을 기준으로 합니다. 문의 사항은 고객센터로 연락 주시기 바랍니다.'
    },
    Region: '지역',
    Server: '서버',
    ServerPlaceholder: '서버',
    CharacterID: '캐릭터 ID',
    CharacterName: '캐릭터',
    RoleName: '닉네임',
    bundelDetails: '상품정보',
    protocal: {
      services: '이용약관',
      policy: '개인정보 취급방침',
      address: '5, 8/F, Mega Cube, 8 Wang Kwong Road, Kowloon Bay, Kowloon, Hong Kong',
      ysAddress: 'ward 7, North Jhagrakhand , maharana pratap ward, manendragarh, koriya, chhattisgarh Manendragarh - 497446',
    },
    dialogMessage: {
      reenter: '캐릭터 정보 변경하시겠습니까?',
      selectServer: '서버를 선택하십시오.',
      selectRoleId: '캐릭터 id를 기입해주세요',
      fillCharacterID: '캐릭터 ID 입력하세요.',
      confirmCharacter: '캐릭터 정보를 확인하세요.'
    },
    footer: {
      safe: {
        title: '안전',
        subTitle: '공식 충전 센터'
      },
      convenient: {
        title: '편리',
        subTitle: '원클릭 구매 및 빠른 결제'
      },
      economical: {
        title: '혜택',
        subTitle: '다양한 리베이트'
      },
      efficient: {
        title: '효율성',
        subTitle: '지연 없는 지급'
      }
    },
    announce: {
      type: '활동'
    }
  },
  paySubmit: {
    paymenMethod: '지불 방식',
    prodDetails: '상품상세정보',
    discount: '할인',
    discountCode: '할인 코드',
    submit: '결제하기',
    total: '총계',
    fillDiscountCode: '할인 코드를 입력하세요',
    protocal: '운영 정책과 아이템 가격 확인 및 동의',
    agree: '통일 협의',
    currentRegion: '현재 지역',
    paymentMethods: '지불 방법',
    items: '항목',
  },
  payFail: {
    title: '결제에 실패했습니다. 다시 시도해 주세요.',
    desc: '문제가 계속될 경우, 다른 결제 수단을 이용해 보시거나 고객센터에 문의해 주세요.',
    loading: '주문 상태 확인 중...',
    apiError: '서비스 오류, 나중에 다시 시도해 주세요.',
  }
};
